export const appUrl = (import.meta.env.VITE_APP_URL ?? 'https://pulp-pwa.web.app').replace(
  /\/$/,
  ''
);

export function profileShareUrl(uid: string): string {
  return `${appUrl}/profile/${uid}`;
}
